import { Notify } from 'quasar';


function keyToMessage(key, data) {
    switch (key) {
        case 'create.cases.vehicleNotAvailable': return `Vozidlo vám na daný termín někdo právě vyfoukl.`;
        case 'update.cases.vehicleNotAvailable': return `Vozidlo vám na daný termín někdo právě vyfoukl.`;
        case 'terms.fileNotFound': return `Všeobecné obchodní podmínky nenalezeny.`;
    }

    if (/update\.[A-Za-z]+\.(?:op|session)LevelConflict/.test(key))
        return 'Detekována souběžná editace. Obnovte prosím stránku a proveďte své úpravy znovu.';

    if (/[A-Za-z]+\.pdf\.generator\.connectionError/.test(key))
        return 'Při generování PDF nastala chyba spojení.';

    if (/[A-Za-z]+\.pdf\.generator\.apiError/.test(key))
        return 'Generování PDF se nezdařilo.';

    return wrapInfo(key);
}

function wrapInfo(info) {
    return `Chyba při volání API: ${info}`;
}


export function notifyOnApiError(err) {
    const resp = err.response;
    const message = (
        !resp ? wrapInfo(err.message) :
        !resp.data ? wrapInfo(`${resp.status} ${resp.statusText}`) :
        !resp.data.key ? wrapInfo(resp.data.message) :
        keyToMessage(resp.data.key, resp.data.data)
    );

    notifyError(message);
}

export function notifyInfo(message) {
    Notify.create({
        message,
        color: 'blue',
        // icon: 'info',
        icon: 'eye-see',
    });
}

export function notifyOk(message) {
    Notify.create({
        message,
        color: 'green',
        // icon: 'check_circle',
        icon: 'office-location',
    });
}

export function notifyWarn(message) {
    Notify.create({
        message,
        color: 'orange',
        // icon: 'warning',
        icon: 'flash',
    });
}

export function notifyError(message) {
    Notify.create({
        message,
        color: 'red',
        icon: 'error',
    });
}
